// S1000D SNS Hierarchy — strict mapping of system -> sub-system -> sub-sub-system
// Only codes that exist in the standard are included.
// Structure: { systemCode: { name, subSystems: { subSysCode: { name, subSubSystems: { sssCode: name } } } } }

export const SNS_HIERARCHY = {
  "00": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "04": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "05": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Time limits", subSubSystems: { "0": "General" } },
      "2": { name: "Scheduled maintenance checks", subSubSystems: { "0": "General" } },
      "5": { name: "Unscheduled maintenance checks", subSubSystems: { "0": "General" } },
    }
  },
  "06": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Dimensions", subSubSystems: { "0": "General" } },
      "2": { name: "Areas", subSubSystems: { "0": "General" } },
    }
  },
  "07": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Jacking", subSubSystems: { "0": "General" } },
      "2": { name: "Shoring", subSubSystems: { "0": "General" } },
    }
  },
  "08": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Weighing and balancing", subSubSystems: { "0": "General" } },
      "2": { name: "Leveling", subSubSystems: { "0": "General" } },
    }
  },
  "09": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Towing", subSubSystems: { "0": "General" } },
      "2": { name: "Taxiing/Maneuvering", subSubSystems: { "0": "General" } },
    }
  },
  "10": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Parking and storage", subSubSystems: { "0": "General" } },
      "2": { name: "Mooring", subSubSystems: { "0": "General" } },
      "3": { name: "Return to service", subSubSystems: { "0": "General" } },
    }
  },
  "11": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Exterior colour schemes and markings", subSubSystems: { "0": "General" } },
      "2": { name: "Exterior placards and markings", subSubSystems: { "0": "General" } },
      "3": { name: "Interior placards", subSubSystems: { "0": "General" } },
    }
  },
  "12": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Replenishing", subSubSystems: { "0": "General" } },
      "2": { name: "Scheduled servicing", subSubSystems: { "0": "General" } },
      "3": { name: "Unscheduled servicing", subSubSystems: { "0": "General" } },
    }
  },
  "14": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "15": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "16": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "18": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Vibration analysis", subSubSystems: { "0": "General" } },
      "2": { name: "Noise attenuation", subSubSystems: { "0": "General" } },
    }
  },
  "20": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Rivets", subSubSystems: { "0": "General" } },
      "2": { name: "Bolts", subSubSystems: { "0": "General" } },
      "3": { name: "Bonding", subSubSystems: { "0": "General" } },
      "4": { name: "Hi-lock fasteners", subSubSystems: { "0": "General" } },
      "5": { name: "Sealing", subSubSystems: { "0": "General" } },
    }
  },
  "21": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Compression", subSubSystems: { "0": "General" } },
      "2": { name: "Distribution", subSubSystems: { "0": "General", "1": "Distribution valving" } },
      "3": { name: "Pressurization control", subSubSystems: { "0": "General", "1": "Pressurization controller" } },
      "4": { name: "Heating", subSubSystems: { "0": "General" } },
      "5": { name: "Cooling", subSubSystems: { "0": "General", "1": "Turbo air cooling", "2": "Ram air cooling", "3": "Vapour cycle cooling" } },
      "6": { name: "Temperature control", subSubSystems: { "0": "General", "1": "Temperature controller" } },
      "7": { name: "Humidity/Air contamination control", subSubSystems: { "0": "General" } },
    }
  },
  "22": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Autopilot", subSubSystems: { "0": "General" } },
      "2": { name: "Speed-attitude correction", subSubSystems: { "0": "General" } },
      "3": { name: "Auto throttle", subSubSystems: { "0": "General" } },
      "4": { name: "System monitor", subSubSystems: { "0": "General" } },
      "5": { name: "Flight management computing", subSubSystems: { "0": "General" } },
    }
  },
  "23": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "HF communications", subSubSystems: { "0": "General", "1": "HF 1", "2": "HF 2", "5": "SATCOM" } },
      "2": { name: "VHF communications", subSubSystems: { "0": "General", "1": "VHF 1", "2": "VHF 2", "3": "VHF 3" } },
      "3": { name: "Passenger address/Entertainment", subSubSystems: { "0": "General" } },
      "4": { name: "Interphone", subSubSystems: { "0": "General" } },
      "5": { name: "Audio integrating", subSubSystems: { "0": "General" } },
      "6": { name: "Static discharging", subSubSystems: { "0": "General" } },
      "7": { name: "Audio/Video monitoring", subSubSystems: { "0": "General" } },
      "8": { name: "Integrated automatic calling", subSubSystems: { "0": "General" } },
    }
  },
  "24": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Generator drive", subSubSystems: { "0": "General" } },
      "2": { name: "AC generation", subSubSystems: { "0": "General", "1": "AC generator 1", "2": "AC generator 2" } },
      "3": { name: "DC generation", subSubSystems: { "0": "General", "1": "Battery 1", "2": "Battery 2" } },
      "4": { name: "External power", subSubSystems: { "0": "General" } },
      "5": { name: "AC electrical load distribution", subSubSystems: { "0": "General" } },
      "6": { name: "DC electrical load distribution", subSubSystems: { "0": "General" } },
    }
  },
  "25": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Flight compartment", subSubSystems: { "0": "General" } },
      "2": { name: "Passenger compartment", subSubSystems: { "0": "General" } },
      "3": { name: "Buffet/Galley", subSubSystems: { "0": "General" } },
      "4": { name: "Lavatories", subSubSystems: { "0": "General" } },
      "5": { name: "Cargo compartments", subSubSystems: { "0": "General" } },
      "6": { name: "Emergency equipment", subSubSystems: { "0": "General" } },
      "7": { name: "Accessory compartments", subSubSystems: { "0": "General" } },
      "8": { name: "Insulation", subSubSystems: { "0": "General" } },
    }
  },
  "26": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Detection", subSubSystems: { "0": "General" } },
      "2": { name: "Extinguishing", subSubSystems: { "0": "General" } },
      "3": { name: "Explosion suppression", subSubSystems: { "0": "General" } },
    }
  },
  "27": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Aileron", subSubSystems: { "0": "General" } },
      "2": { name: "Rudder", subSubSystems: { "0": "General" } },
      "3": { name: "Elevator", subSubSystems: { "0": "General" } },
      "4": { name: "Stabilizer", subSubSystems: { "0": "General" } },
      "5": { name: "Flaps", subSubSystems: { "0": "General", "1": "Trailing edge flaps", "2": "Leading edge devices" } },
      "6": { name: "Spoilers/Speed brakes", subSubSystems: { "0": "General" } },
      "7": { name: "Gust lock/Damper", subSubSystems: { "0": "General" } },
      "8": { name: "Lift augmenting", subSubSystems: { "0": "General" } },
    }
  },
  "28": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Storage", subSubSystems: { "0": "General" } },
      "2": { name: "Distribution", subSubSystems: { "0": "General", "1": "Fuel feed", "2": "Fuel transfer", "3": "Fuel jettison" } },
      "3": { name: "Dump", subSubSystems: { "0": "General" } },
      "4": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "29": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Main system", subSubSystems: { "0": "General" } },
      "2": { name: "Auxiliary system", subSubSystems: { "0": "General" } },
      "3": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "30": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Airfoil", subSubSystems: { "0": "General" } },
      "2": { name: "Air intakes", subSubSystems: { "0": "General" } },
      "3": { name: "Pitot/Static", subSubSystems: { "0": "General" } },
      "4": { name: "Windows/Windshields", subSubSystems: { "0": "General" } },
      "5": { name: "Antennas/Radomes", subSubSystems: { "0": "General" } },
      "6": { name: "Propellers/Rotors", subSubSystems: { "0": "General" } },
      "7": { name: "Water lines", subSubSystems: { "0": "General" } },
      "8": { name: "Drains", subSubSystems: { "0": "General" } },
    }
  },
  "31": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Indicating/Recording instruments", subSubSystems: { "0": "General" } },
      "2": { name: "Flight data recording", subSubSystems: { "0": "General" } },
      "3": { name: "Central computers", subSubSystems: { "0": "General" } },
      "4": { name: "Central warning", subSubSystems: { "0": "General" } },
      "5": { name: "Central display", subSubSystems: { "0": "General" } },
      "6": { name: "Integrated display", subSubSystems: { "0": "General" } },
    }
  },
  "32": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Main gear and doors", subSubSystems: { "0": "General", "1": "Main gear strut", "2": "Main gear actuator" } },
      "2": { name: "Nose/Tail gear and doors", subSubSystems: { "0": "General", "1": "Nose gear strut", "2": "Nose gear actuator" } },
      "3": { name: "Extension and retraction", subSubSystems: { "0": "General" } },
      "4": { name: "Wheels and brakes", subSubSystems: { "0": "General", "1": "Main gear wheels", "2": "Nose gear wheels", "3": "Brake system" } },
      "5": { name: "Steering", subSubSystems: { "0": "General" } },
      "6": { name: "Position and warning", subSubSystems: { "0": "General" } },
      "7": { name: "Supplementary gear", subSubSystems: { "0": "General" } },
    }
  },
  "33": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Flight compartment", subSubSystems: { "0": "General" } },
      "2": { name: "Passenger compartment", subSubSystems: { "0": "General" } },
      "3": { name: "Cargo compartment", subSubSystems: { "0": "General" } },
      "4": { name: "Exterior", subSubSystems: { "0": "General" } },
      "5": { name: "Emergency", subSubSystems: { "0": "General" } },
    }
  },
  "34": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Flight environment data", subSubSystems: { "0": "General" } },
      "2": { name: "Attitude and direction", subSubSystems: { "0": "General", "1": "Attitude", "2": "Direction" } },
      "3": { name: "Landing and taxi aids", subSubSystems: { "0": "General" } },
      "4": { name: "Independent position determining", subSubSystems: { "0": "General", "1": "Inertial", "2": "GPS" } },
      "5": { name: "Dependent position determining", subSubSystems: { "0": "General", "1": "DME", "2": "ATC transponder" } },
      "6": { name: "Flight management computing", subSubSystems: { "0": "General" } },
    }
  },
  "35": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Crew", subSubSystems: { "0": "General" } },
      "2": { name: "Passenger", subSubSystems: { "0": "General" } },
      "3": { name: "Portable", subSubSystems: { "0": "General" } },
    }
  },
  "36": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Distribution", subSubSystems: { "0": "General" } },
      "2": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "37": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "38": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Potable water", subSubSystems: { "0": "General" } },
      "2": { name: "Wash water", subSubSystems: { "0": "General" } },
      "3": { name: "Waste disposal", subSubSystems: { "0": "General" } },
      "4": { name: "Air supply", subSubSystems: { "0": "General" } },
    }
  },
  "39": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "40": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "41": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "42": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Core system", subSubSystems: { "0": "General" } },
      "2": { name: "Network components", subSubSystems: { "0": "General" } },
      "3": { name: "Software/Applications", subSubSystems: { "0": "General" } },
    }
  },
  "43": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "44": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Cabin core system", subSubSystems: { "0": "General" } },
      "2": { name: "In-flight entertainment", subSubSystems: { "0": "General" } },
      "3": { name: "External communication", subSubSystems: { "0": "General" } },
      "4": { name: "Cabin mass memory", subSubSystems: { "0": "General" } },
      "5": { name: "Cabin monitoring", subSubSystems: { "0": "General" } },
    }
  },
  "45": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Central maintenance computer", subSubSystems: { "0": "General" } },
      "2": { name: "Data loading", subSubSystems: { "0": "General" } },
      "3": { name: "Electronic library", subSubSystems: { "0": "General" } },
      "4": { name: "Printing", subSubSystems: { "0": "General" } },
      "5": { name: "Health/Usage monitoring", subSubSystems: { "0": "General" } },
    }
  },
  "46": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Displays", subSubSystems: { "0": "General" } },
      "2": { name: "Integrated systems", subSubSystems: { "0": "General" } },
    }
  },
  "47": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "48": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "49": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "50": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "51": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "52": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Passenger/Crew doors", subSubSystems: { "0": "General" } },
      "2": { name: "Emergency exit", subSubSystems: { "0": "General" } },
      "3": { name: "Cargo doors", subSubSystems: { "0": "General" } },
      "4": { name: "Service and miscellaneous", subSubSystems: { "0": "General" } },
      "5": { name: "Fixed interior", subSubSystems: { "0": "General" } },
      "6": { name: "Entrance stairs", subSubSystems: { "0": "General" } },
      "7": { name: "Door warning", subSubSystems: { "0": "General" } },
      "8": { name: "Landing gear doors", subSubSystems: { "0": "General" } },
    }
  },
  "53": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Main frame", subSubSystems: { "0": "General" } },
      "2": { name: "Auxiliary structure", subSubSystems: { "0": "General" } },
      "3": { name: "Plates/Skin", subSubSystems: { "0": "General" } },
      "4": { name: "Attach fittings", subSubSystems: { "0": "General" } },
      "5": { name: "Aerodynamic fairings", subSubSystems: { "0": "General" } },
    }
  },
  "54": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Nacelle section", subSubSystems: { "0": "General" } },
      "2": { name: "Pylon", subSubSystems: { "0": "General" } },
    }
  },
  "55": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Horizontal stabilizer", subSubSystems: { "0": "General" } },
      "2": { name: "Elevator", subSubSystems: { "0": "General" } },
      "3": { name: "Vertical stabilizer", subSubSystems: { "0": "General" } },
      "4": { name: "Rudder", subSubSystems: { "0": "General" } },
    }
  },
  "56": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Flight compartment", subSubSystems: { "0": "General" } },
      "2": { name: "Passenger compartment", subSubSystems: { "0": "General" } },
      "3": { name: "Door windows", subSubSystems: { "0": "General" } },
      "4": { name: "Inspection/Observation", subSubSystems: { "0": "General" } },
    }
  },
  "57": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Centre wing", subSubSystems: { "0": "General" } },
      "2": { name: "Outer wing", subSubSystems: { "0": "General" } },
      "3": { name: "Wing tip", subSubSystems: { "0": "General" } },
      "4": { name: "Leading edge/Slats", subSubSystems: { "0": "General" } },
      "5": { name: "Trailing edge flaps", subSubSystems: { "0": "General" } },
      "6": { name: "Ailerons/Elevons", subSubSystems: { "0": "General" } },
      "7": { name: "Spoilers", subSubSystems: { "0": "General" } },
    }
  },
  "60": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "61": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Propeller assembly", subSubSystems: { "0": "General" } },
      "2": { name: "Controlling", subSubSystems: { "0": "General" } },
      "3": { name: "Braking", subSubSystems: { "0": "General" } },
      "4": { name: "Indicating", subSubSystems: { "0": "General" } },
      "5": { name: "Propulsor duct", subSubSystems: { "0": "General" } },
    }
  },
  "62": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Main rotor blades", subSubSystems: { "0": "General" } },
      "2": { name: "Main rotor head", subSubSystems: { "0": "General" } },
      "3": { name: "Main rotor mast/Swashplate", subSubSystems: { "0": "General" } },
      "4": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "63": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Engine/Gearbox couplings", subSubSystems: { "0": "General" } },
      "2": { name: "Gearboxes", subSubSystems: { "0": "General" } },
      "3": { name: "Mounts/Attachments", subSubSystems: { "0": "General" } },
      "4": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "64": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Tail rotor blades", subSubSystems: { "0": "General" } },
      "2": { name: "Tail rotor head", subSubSystems: { "0": "General" } },
      "3": { name: "Tail rotor indicating", subSubSystems: { "0": "General" } },
    }
  },
  "65": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Tail rotor drive shafts", subSubSystems: { "0": "General" } },
      "2": { name: "Tail rotor gearbox", subSubSystems: { "0": "General" } },
      "3": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "66": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "67": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "68": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "70": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "71": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Cowling", subSubSystems: { "0": "General" } },
      "2": { name: "Mounts", subSubSystems: { "0": "General" } },
      "3": { name: "Fireseals", subSubSystems: { "0": "General" } },
      "4": { name: "Attach fittings", subSubSystems: { "0": "General" } },
      "5": { name: "Electrical harness", subSubSystems: { "0": "General" } },
      "6": { name: "Air intakes", subSubSystems: { "0": "General" } },
      "7": { name: "Engine drains", subSubSystems: { "0": "General" } },
    }
  },
  "72": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Turbine/Turboprop", subSubSystems: { "0": "General" } },
      "2": { name: "Reciprocating", subSubSystems: { "0": "General" } },
      "3": { name: "Reciprocating supercharger", subSubSystems: { "0": "General" } },
      "5": { name: "Propulsion augmentation (turbo)", subSubSystems: { "0": "General" } },
      "6": { name: "Propulsion augmentation (recip)", subSubSystems: { "0": "General" } },
    }
  },
  "73": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Distribution", subSubSystems: { "0": "General" } },
      "2": { name: "Controlling", subSubSystems: { "0": "General" } },
      "3": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "74": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Electrical power supply", subSubSystems: { "0": "General" } },
      "2": { name: "Distribution", subSubSystems: { "0": "General" } },
    }
  },
  "75": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Engine anti-icing", subSubSystems: { "0": "General" } },
      "2": { name: "Cooling", subSubSystems: { "0": "General" } },
      "3": { name: "Compressor control", subSubSystems: { "0": "General" } },
      "4": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "76": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Power control", subSubSystems: { "0": "General" } },
      "2": { name: "Emergency shutdown", subSubSystems: { "0": "General" } },
    }
  },
  "77": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Power", subSubSystems: { "0": "General" } },
      "2": { name: "Temperature", subSubSystems: { "0": "General" } },
      "3": { name: "Analyzers", subSubSystems: { "0": "General" } },
    }
  },
  "78": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Collector/Nozzle", subSubSystems: { "0": "General" } },
      "2": { name: "Noise suppressor", subSubSystems: { "0": "General" } },
      "3": { name: "Thrust reverser", subSubSystems: { "0": "General" } },
      "4": { name: "Supplemental air", subSubSystems: { "0": "General" } },
    }
  },
  "79": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Storage", subSubSystems: { "0": "General" } },
      "2": { name: "Distribution", subSubSystems: { "0": "General" } },
      "3": { name: "Indicating", subSubSystems: { "0": "General" } },
    }
  },
  "80": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Cranking", subSubSystems: { "0": "General" } },
    }
  },
  "81": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "82": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "83": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "84": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "85": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "86": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "87": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "90": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "91": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Wiring", subSubSystems: { "0": "General" } },
    }
  },
  "92": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Weather radar", subSubSystems: { "0": "General" } },
      "2": { name: "Ground mapping radar", subSubSystems: { "0": "General" } },
    }
  },
  "93": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "94": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Guns", subSubSystems: { "0": "General" } },
      "2": { name: "Guided missiles", subSubSystems: { "0": "General" } },
      "3": { name: "Rocket systems", subSubSystems: { "0": "General" } },
    }
  },
  "95": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
      "1": { name: "Crew escape", subSubSystems: { "0": "General" } },
      "2": { name: "Crew safety equipment", subSubSystems: { "0": "General" } },
    }
  },
  "96": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "97": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "98": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  "99": {
    subSystems: {
      "0": { name: "General", subSubSystems: { "0": "General" } },
    }
  },
  // Land Vehicle codes
  "A0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A3": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A4": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A5": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A6": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A7": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A8": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "A9": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B3": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B4": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B5": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B6": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B7": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "B8": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "C0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "D0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "D1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "D2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "D3": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "D4": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "D5": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "E0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "E1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "E2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "E3": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "E4": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "F0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "F1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "G0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "G1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "H0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "H1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "J0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "J1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "K0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "K1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "K2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "L0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "L1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "M0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "M1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "M2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "M3": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "N0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "N1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "N2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "N3": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "P0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "P1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "P2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "P3": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "P4": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "Q0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "Q1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "Q2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "R0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "R1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "S0": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "S1": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "S2": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "S3": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
  "S4": { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } },
};

// Default fallback for unknown system codes
const DEFAULT_HIERARCHY = { subSystems: { "0": { name: "General", subSubSystems: { "0": "General" } } } };

// Helper: Get sub-system options for a given system code
export function getSubSystemsForSystem(systemCode) {
  const system = SNS_HIERARCHY[systemCode] || DEFAULT_HIERARCHY;
  return Object.entries(system.subSystems).map(([code, data]) => ({ code, name: data.name }));
}

// Helper: Get sub-sub-system options for a given system + sub-system (strict — only defined codes)
export function getSubSubSystemsForSubSystem(systemCode, subSystemCode) {
  const system = SNS_HIERARCHY[systemCode] || DEFAULT_HIERARCHY;
  const subSystem = system.subSystems[subSystemCode];
  if (!subSystem) return [{ code: "0", name: "General" }];
  return Object.entries(subSystem.subSubSystems).map(([code, name]) => ({ code, name }));
}
